// ============================================================
// GGPlayer v4 — Standalone bundle entry point
// Single-file bundle with CSS inlined, all deps bundled
// Exposes legacy-compatible API for: new GGPlayer2(config)
// Supports both modern and legacy (v3) API patterns
// ============================================================
import { GGPlayerLegacy } from './compat/LegacyAdapter';
import { GGPlayer2InWindowAdapter } from './compat/GGPlayer2InWindowAdapter';
import { GGPlayer } from './GGPlayer';

// Extend window interface to include Player2
declare global {
  interface Window {
    GGPlayer2: typeof GGPlayerLegacy;
    GGPlayer2Clean: typeof GGPlayer;
    GGPlayer2InWindowAdapter: typeof GGPlayer2InWindowAdapter;
  }
}

// Expose on window for global access
if (typeof window !== 'undefined') {
  window.GGPlayer2 = GGPlayerLegacy;
  window.GGPlayer2Clean = GGPlayer;
  window.GGPlayer2InWindowAdapter = GGPlayer2InWindowAdapter;
  
}

// Export LegacyAdapter as default for v3 API compatibility:
// - player.appendUserData()
// - player.appendClipsStatus()
// - player.onStart(), player.onStop(), player.onViewers()
export default GGPlayerLegacy;
